import ExpandedRowContent from "./expanded-row/ExpandedRowContent";

function renderRowExpanded(rowData) {
  return <ExpandedRowContent rowData={rowData} rowKey="id" />;
}

export default renderRowExpanded;
